import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import { WrapperBlock, TheadProps, ColProps } from './types'

export const Wrapper = styled(Box)<WrapperBlock>`
  overflow-x: auto;
  width: 100%;
  ${({ marginTop }) => css`
    margin-top: ${marginTop};
  `}
`

export const WrapperTable = styled.table`
  margin: auto;
  overflow-x: auto;
  width: 655px;
`

export const WrapperCol = styled.col<ColProps>`
  ${({ color }) => css`
    background-color: ${color};
  `}
`

export const TH = styled.th<TheadProps>`
  ${({ theme, colors }) => css`
    background: ${colors[1]};
    color: ${theme.newColors.primary};
    :first-of-type {
      background: ${colors[0]};
    }
    :last-of-type {
      background: ${colors[2]};
    }
    ${theme.getTypography('desktop', 'title', 'title4')};
    padding: ${theme.newSpaces.xs}px;
  `}
`

export const TD = styled.td`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')};
    color: ${theme.newColors.primary};
    padding: 10px;
  `}
`
